import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02055ddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "window"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Warranty Claim", -1 /* HOISTED */))
const _hoisted_5 = { class: "title-div" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lbl-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "SSWS Conversion of CMAP & CMRB")
], -1 /* HOISTED */))
const _hoisted_7 = { class: "title-CMAP-Err-btn" }
const _hoisted_8 = {
  key: 0,
  class: "required",
  style: {"font-size":"small"}
}
const _hoisted_9 = { class: "CMAP-div" }
const _hoisted_10 = { class: "CMAP-title-div" }
const _hoisted_11 = { class: "lbl-title-CMAP" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"5rem"} }, "CMAP", -1 /* HOISTED */))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "upload-div" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Entry Station Code"),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createTextVNode("Receiving Station Code"),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createTextVNode("Distributor Code"),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createTextVNode("Lot No."),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
  ])
], -1 /* HOISTED */))
const _hoisted_16 = { style: {"vertical-align":"center"} }
const _hoisted_17 = { style: {"background-color":"whitesmoke","border":"1px solid lightgray","padding":"2px 6px"} }
const _hoisted_18 = { style: {"position":"relative","display":"inline-block"} }
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  class: "error_tooltip"
}
const _hoisted_21 = { style: {"position":"relative","display":"inline-block"} }
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  key: 0,
  class: "error_tooltip"
}
const _hoisted_24 = { style: {"position":"relative","display":"inline-block"} }
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 0,
  class: "error_tooltip"
}
const _hoisted_27 = { class: "CMAP-file-upload" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  width: "155rem",
  style: {"font-weight":"bold"}
}, "Data file path", -1 /* HOISTED */))
const _hoisted_29 = { width: "487rem" }
const _hoisted_30 = {
  type: "file",
  ref: "csvFileCMAP",
  accept: ".csv"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divider-div" }, null, -1 /* HOISTED */))
const _hoisted_32 = { class: "CMRB-div" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lbl-title-CMRB" }, "CMRB", -1 /* HOISTED */))
const _hoisted_34 = { class: "CMRB-file-upload" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  width: "150rem",
  style: {"font-weight":"bold"}
}, "Data file path", -1 /* HOISTED */))
const _hoisted_36 = { width: "486.5rem" }
const _hoisted_37 = {
  type: "file",
  ref: "txtFileCMRB",
  accept: ".txt"
}
const _hoisted_38 = { width: "173.5rem" }
const _hoisted_39 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_40 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"max-height":"calc(100% - 150px)"}
}
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel"
  }, " Error Messages "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_43 = { class: "modal-body error-message-show" }
const _hoisted_44 = { style: {"text-align":"left"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal",
    id: "deleteCancel"
  }, "OK")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          ($setup.errorMessage != '')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-Error-Msg-Show text-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showErrorMessage()))
              }, "Error Message"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            ($setup.errorMessage != '')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "※Please click the button above to view error details."))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("button", {
            type: "btutton",
            class: "btn btn-primary text-center",
            disabled: $setup.downloadDisableFlag,
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getCsvFormatFile()))
          }, "Download CMAP.csv", 8 /* PROPS */, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _hoisted_15,
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString($setup.entryStationCode), 1 /* TEXT */)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "4",
                    id: "txtReceStCd",
                    class: _normalizeClass(["input-field uppercase", {'input_error':$setup.receivingStationCodeError}]),
                    title: $setup.receivingStationCodeError,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.receivingStationCode) = $event))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_19), [
                    [_vModelText, $setup.receivingStationCode]
                  ]),
                  ($setup.receivingStationCodeError != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "{receivingStationCodeError}"))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "5",
                    id: "txtDist",
                    class: _normalizeClass(["input-field uppercase", {'input_error':$setup.distributorCodeError}]),
                    title: $setup.distributorCodeError,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.distributorCode) = $event))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_22), [
                    [_vModelText, $setup.distributorCode]
                  ]),
                  ($setup.distributorCodeError != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "{distributorCodeError}"))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "4",
                    id: "lotCode",
                    class: _normalizeClass(["input-field uppercase", {'input_error':$setup.lotCodeError}]),
                    title: $setup.lotCodeError,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.lotCode) = $event))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_25), [
                    [_vModelText, $setup.lotCode]
                  ]),
                  ($setup.lotCodeError != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "{lotCodeError}"))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("input", _hoisted_30, null, 512 /* NEED_PATCH */)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  id: "uploadScanPC",
                  type: "btutton",
                  class: "btn btn-primary text-center btn-upload",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.btnUpload()))
                }, "Upload SCAN-PC")
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_31,
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _hoisted_35,
            _createElementVNode("td", _hoisted_36, [
              _createElementVNode("input", _hoisted_37, null, 512 /* NEED_PATCH */)
            ]),
            _createElementVNode("td", _hoisted_38, [
              _createElementVNode("button", {
                type: "btutton",
                class: "btn btn-primary text-center btn-convert",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.btnConvert()))
              }, "Convert")
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, _toDisplayString($setup.modalBody[0]), 1 /* TEXT */)
          ]),
          _hoisted_45
        ])
      ])
    ])
  ]))
}